<template>
  <el-popover placement="bottom" width="200" trigger="click" v-model="visible">
    <div>
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <div class="list">
        <el-checkbox-group v-model="checkedItem" @change="handleCheckedChange" id="items">

          <div class="checkList" v-for="item in list" :key="item.id">
            <el-checkbox :label="item.title" :key="item.id" class="item">{{ item.title }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>

      <div style="margin-top: 8px;">
        <el-button size="mini" @click="getChecked"> 确认 </el-button>
        <!-- <el-button size="mini"> 还原</el-button> -->
      </div>

    </div>
    <!-- <el-button slot="reference">click </el-button> -->
    <div slot="reference" class="cl"> <i class="vxe-icon-custom-column icon"></i></div>
  </el-popover>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      checkedItem: [],
      // cities: [],
      list: [],
      visible: false
    }
  },


  props: ['dataList'],
  methods: {
    // handleCheckedChange(){},
    handleCheckAllChange(val) {

      const list = this.list.map(i => i.title)
      this.checkedItem = val ? list : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      // console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
    },

    getChecked() {

      this.$emit('saveCol', [this.checkedItem, this.list]);
      this.visible = false

    },
    sortEl() {
      var that = this
      var el = document.getElementById('items');
      // 常用
      new Sortable(el, {
        animation: 350,
        onEnd: function (evt) {
          const { newIndex: nI, oldIndex: oI } = evt;

          that.list.splice(nI, 0, that.list.splice(oI, 1)[0])
          var newArray = that.list.slice(0)

          that.$nextTick(function () {
            that.list = newArray
          })
        }
      })
    }
  },
  watch: {
    dataList(e) {

      const { checked, All = [] } = e;
      this.checkedItem = checked;
      this.list = All.map((i, e) => ({ title: i.title, id: 'n' + e }))
    }
  },
  mounted() {
    // console.log(this.$store.state.elementHight);
    const { checked, All = [] } = this.dataList;
    this.checkedItem = checked;
    this.list = All.map((i, e) => ({ title: i.title, id: 'n' + e }))
    this.sortEl();
  },
  // created()
}
</script>

<style scoped>
.cl {
  width: 35px;
  height: 35px;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
  box-sizing: border-box;
  margin-right: 12px;
}

.cl .icon:hover {
  color: #4b92ff;
}

.list {
  max-height: 220px;
  overflow-y: auto;
  box-sizing: content-box;
}

.checkList li {
  list-style: none;
  float: left;
}

.item {
  width: 100%;
  margin: 2px 0;
  padding: 2px 5px;
  box-sizing: border-box;
}

.item:hover {
  background-color: #eee;
}
</style>